import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { useAuthStore } from '../../auth/stores/authStore';

export const plotDetailsKeys = {
  all: ['plotDetails'] as const,
  details: () => [...plotDetailsKeys.all, 'detail'] as const,
  detail: (siteId: number, plotId: number, isAuthenticated: boolean) =>
    [
      ...plotDetailsKeys.details(),
      { siteId, plotId, isAuthenticated },
    ] as const,
};

/**
 * Hook to fetch plot detail using the v2 API.
 * Requires both siteId and plotId since the v2 endpoint is site-scoped.
 */
export function usePlotDetails(siteId: number | null, plotId: number | null) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  const { data, error, isFetching } = useQuery({
    queryKey: plotDetailsKeys.detail(siteId || 0, plotId || 0, isAuthenticated),
    queryFn: async ({ signal }) =>
      unwrap(
        await api.legacy.GET('/api/v2/sites/{siteId}/plots/{plotId}', {
          params: { path: { siteId: siteId!, plotId: plotId! } },
          signal,
        })
      ),
    placeholderData: previousData => previousData,
    enabled: isAuthenticated && !!siteId && !!plotId,
    staleTime: 30000,
  });

  return { data, error, isFetching };
}
